export const OCV_FEEDBACK_LAUNCH_BEGIN = 'OCV_FEEDBACK_LAUNCH_BEGIN';
export const OCV_FEEDBACK_FORM_LAUNCHED = 'OCV_FEEDBACK_FORM_LAUNCHED';
export const OCV_FEEDBACK_FORM_DISMISSED = 'OCV_FEEDBACK_FORM_DISMISSED';
export const OCV_FEEDBACK_FORM_SUBMITTED = 'OCV_FEEDBACK_FORM_SUBMITTED';
export const OCV_FEEDBACK_FORM_ERROR = 'OCV_FEEDBACK_FORM_ERROR';
export const OCV_FEEDBACK_LAUNCH_ERROR = 'OCV_FEEDBACK_LAUNCH_ERROR';
export const OCV_FEEDBACK_LAUNCH_RETRY_CLICK = 'OCV_FEEDBACK_LAUNCH_RETRY_CLICK';
